import React, { useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';

const GoogleMissingEmail = () => {
    const [email, setEmail] = useState('');
    const [error, setError] = useState('');
    const navigate = useNavigate();

    const handleSubmit = async (e) => {
        e.preventDefault();
    
        try {
            const googleId = new URLSearchParams(window.location.search).get('googleId');
            console.log('Google ID:', googleId); // Debugging line
            const apiUrl = process.env.REACT_APP_API_URL || 'http://localhost:5000'; // Fallback to localhost
            const response = await axios.post(`${apiUrl}/api/users/google/manual-email`, {
                googleId,
                email,
            });
    
            // Save the token and redirect
            localStorage.setItem('user', JSON.stringify({ token: response.data.token }));
            navigate('/');
        } catch (err) {
            setError(err.response?.data?.message || 'An error occurred.');
        }
    };

    return (
        <div className="google-missing-email-container">
            <h2>Provide Your Email</h2>
            <p>We couldn't retrieve your email from Google. Please provide it below to complete the login process.</p>
            {error && <p className="error">{error}</p>}
            <form onSubmit={handleSubmit}>
                <label>Email</label>
                <input
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                />
                <button type="submit">Submit</button>
            </form>
        </div>
    );
};

export default GoogleMissingEmail;